module.exports = __webpack_public_path__ + "img/img5.526789b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img5.png
// module id = 269
// module chunks = 0